module.exports = __webpack_public_path__ + "static/media/radio_checked_desktop.bbab2d1a.svg";